import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  banners: [],
  allBanners: [],
  addPackageData: [],
};

export const PackagesSlice = createSlice({
  name: "banners",
  initialState,
  reducers: {
    getBannerAction: (state, action) => {
      
      state.allBanners = action.payload;
    },
    getAddBannerDataAction: (state, action) => {
      
      state.addBannerData = action.payload;
    },
    getSingleBannerAction: (state, action) => {
      
      state.banners = action.payload;
    },
  },
});

export default PackagesSlice.reducer;

export const { getBannerAction, getSingleBannerAction, getAddBannerDataAction } = PackagesSlice.actions;
